import { Link } from 'react-router-dom';
import { AppPage } from '../layouts/AppPage';

export function NotFound() {
  return (
    <AppPage title="Page not found">
      <section style={{ textAlign: 'center', padding: '32px 16px 48px' }}>
        <img
          src="/illustrations/errors/not-found-404.png"
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
          style={{
            width: 240,
            maxWidth: '70%',
            height: 'auto',
            margin: '0 auto 24px',
            display: 'block',
          }}
        />
        <h2 style={{ fontSize: 24, marginBottom: 8 }}>You've wandered off the map</h2>
        <p
          style={{
            fontSize: 17,
            color: 'var(--color-text-secondary)',
            maxWidth: 460,
            margin: '0 auto 24px',
          }}
        >
          We could not find that page. Use the link below to head back home.
        </p>
        <Link to="/" className="home-hero__cta">
          Return to MedReview home
        </Link>
      </section>
    </AppPage>
  );
}
